<div>
    
      
    <!-- Main Content -->
    <div class="main-content">
        <header class="top-header">
            <h3>Add Camera</h3>
        </header>
        
        <form class="form" [formGroup]="cameraForm" (ngSubmit)="onSubmit()">
            <div class="form-row">
                <div class="form-group">
                    <label>Eagle Eye Camera ESN <small>*</small></label>
                    <input type="text" placeholder="Enter Eagle Eye camera ESN" formControlName="cameraESN">
                    <small class="helper-text">
                        Enter the camera ESN from Eagle Eye Networks. KYRA does not generate this value.
                    </small>
                    <div class="error"
                         *ngIf="cameraForm.get('cameraESN')?.invalid && cameraForm.get('cameraESN')?.touched">
                        <small *ngIf="cameraForm.get('cameraESN')?.errors?.['required']">Camera ESN is required.</small>
                    </div>
                </div>
                <div class="form-group">
                    <label>Organization Name <small>*</small></label>
                    <input id="organization"  formControlName="organization" readonly />
                    <!-- <div  class="error" *ngIf="cameraForm.get('organization')?.invalid && cameraForm.get('organization')?.touched">
                        <small *ngIf="cameraForm.get('organization')?.errors?.['required']">Organization Name is required.</small>
                    </div> -->
                </div>
                
            </div>
            <div class="form-row">
                <div class="form-group">
                    <label>Direction <small>*</small></label>
                    <select formControlName="direction" id="direction">
                        <option *ngFor="let option of directionChoice" [value]="option">{{ option }}</option>
                    </select>
                    <!-- <input type="text" placeholder="Direction" formControlName="direction"> -->
                    <div  class="error" *ngIf="cameraForm.get('direction')?.invalid && cameraForm.get('direction')?.touched">
                        <small *ngIf="cameraForm.get('direction')?.errors?.['required']">Direction is required.</small>
                    </div>
                </div>
                <div class="form-group">
                    <label for="description">Camera Name <small>*</small></label>
                    <input type="text" id="description" placeholder="Camera Name" formControlName="description">
                    <div  class="error" *ngIf="cameraForm.get('description')?.invalid && cameraForm.get('description')?.touched">
                        <small *ngIf="cameraForm.get('description')?.errors?.['required']">Camera Name is required.</small>
                    </div>
                </div>
                
            </div>
            <div class="button-row">
                <button class="btn-save" type="submit">
                    <fa-icon [icon]="['fas', 'square-plus']" style="padding-right: 3px;" ></fa-icon>
                    ADD
                </button>
                <button class="btn-cancel" type="button" (click)="onCancel()">
                    <fa-icon [icon]="['fas', 'square-xmark']" style="padding-right: 3px;" ></fa-icon>
                    Cancel
                </button>
            </div>
        </form>
    </div>
</div>
